module.exports = __webpack_public_path__ + "img/menu-multiple-sites.fa8639a2.svg";